module.exports = __webpack_public_path__ + "/images/ico-to-top.2e07fc6.svg";